<template>
    <div>
        <div>
            <h1>
                Alle für einen
            </h1>
            <div class="slidetext">
                Unser Team aus strukturierten Strategen, geistreichen Gestaltern und effizienten Entwicklern ist bereit
                mit Ihnen die Welt zu erobern. Und mit uns ein Netzwerk hochqualifizierter Partnern aus verschiedenen
                Branchen.
            </div>
        </div>
        <transition-group @enter="enterMembers"  >
            <div class="member" v-for="t in team"  :key="t.title.rendered" v-if="showMembers"
                 :style="{'top':t.acf.koordinaten.oben + '%', 'left':t.acf.koordinaten.links + '%'}">
                <!--        {{team}}-->
                <div class="img" :style="{backgroundImage: `url(${t._embedded['wp:featuredmedia']['0'].source_url})`}">
                    <!--                    <img :src="" alt="">-->
                    <div class="text">
                        <div class="person">
                            <div class="name">
                                {{t.title.rendered}}
                            </div>
                            <div class="job">
                                {{t.acf.job}}
                            </div>
                        </div>
                        <div class="bio">
                            {{t.acf.kurzbio}}
                        </div>
                    </div>
                </div>
                <br>
            </div>
            <!--            {{t}}-->
        </transition-group>
    </div>
</template>
<script>
    import store from '@/store'
    import Velocity from "velocity-animate";
    export default {
        Velocity,
        store,
        data() {
            return {
                showMembers: false
            }
        },
        created: function () {
            store.dispatch('getTeam');
            setTimeout(function () {
                this.showMembers = true
            }.bind(this), 1000)
        },
        name: "Team",
        computed: {
            team: () => store.state.team,
        },
        methods: {
            enterMembers(el) {
                el.velocity({
                    transform: ['translateX(0)', 'translateX(-100%)'],
                    opacity: [1, 0],
                }, {
                    duration: 500,
                })
            }
        }
    }
</script>
<style scoped lang="scss">
    .slidetext {
        @extend .h3;
        color: $zzgray;
    }
    .member {
        position: absolute;
        .img {
            position: relative;
            width: 50px;
            background-position: center top;
            height: 150px;
            background-size: cover;
            .text {
                justify-content: center;
                display: flex;
                flex-direction: column;
                padding: 30px;
                .person {
                    font-size: 14px;
                    line-height: 140%;
                    padding: 10px 0;
                    .name {
                        font-weight: 700;
                        text-transform: uppercase;
                    }
                    .job {
                        color: $zzcolor;
                    }
                }
                .bio {
                    font-weight: 300;
                    font-size: 18px;
                    line-height: 160%;
                    /* or 29px */
                    letter-spacing: 0.02em;
                }
            }
            img {
                width: 100%;
            }
            &:hover {
                width: 150px;
                .text {
                    opacity: 1;
                }
            }
            .text {
                opacity: 0;
                position: absolute;
                height: 150px;
                width: 300px;
                background: $zzgray;
                top: 100px;
                left: 50px;
                background: rgba(255, 255, 255, 0.85);
                box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.05), 5px 10px 50px rgba(0, 0, 0, 0.1);
                backdrop-filter: blur(10px);
            }
        }
    }
</style>
